export function useDataTableFilterOperators() {
  return {
    EQUALS: "EQUALS",
    NOT_EQUALS: "NOT_EQUALS",
    GREATER_THAN: "GREATER_THAN",
    LESS_THAN: "LESS_THAN",
    GREATER_THAN_OR_EQ: "GREATER_THAN_OR_EQ",
    LESS_THAN_OR_EQ: "LESS_THAN_OR_EQ",
    IN: "IN",
    NOT_IN: "NOT_IN",
    BETWEEN: "BETWEEN",
    LIKE: "LIKE",
    IS_NULL: "IS_NULL",
    NOT_NULL: "NOT_NULL",
  };
}
